import React, { useState } from 'react'
import style from './InteractTwo.module.sass'

const euphemisms = [
    "Strawberry Week", "Auntie's Visit", "Time of the Month",
     "Red Wedding", "Mother Nature's Gift", "Dracula's Sandwich",
    "Special Friend", "Riding the Cotton Unicorn", "Potato Harvest",
    "Shark week", "Mistress Time", "Bloody Mary", "Got my Emma",
    "Venus is Visiting", "Blow-job Week", "Red Army's in Town",
    "Lady Business", "Devil's Waterfall", "Girl Flu", "Russian Army",
    "Crimson Wave", "Code Red", "Bad Luck", "Regular Holiday",
    "Guest", "Niagara Falls"
]

const InteractTwo = (props) => {
    const [wordNumber, setWordNumber] = useState(0)
    setTimeout(() => {
        if (wordNumber < euphemisms.length-1) {
            setWordNumber(wordNumber + 1)
        } else {
            setWordNumber(0)
        }
    }, 2000);


    return (
        <>
         <div className = {`${style.quoteContainer} main`}>
            
             <div className = {`${style.quoteMain} quoteMain`}>“If men could menstruate, <span>periods would be enviable.”</span></div>
             <div className = {`${style.quoteAuthor} quoteAuthor`}>- Gloria Steinem</div>
             
        </div>
         <div className = {`${style.eupheContainer} main`}>
            <div className = {`${style.padContainer} padOne`}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 859 495.972">
                    <g id="Group_39" data-name="Group 39" transform="translate(-866 -3549)">
                        <rect id="Rectangle_11" data-name="Rectangle 11" width="859" height="335.184" rx="146" transform="translate(866 3627.806)" />
                        <rect id="Rectangle_12" data-name="Rectangle 12" width="227.809" height="106.65" rx="39" transform="translate(1175.615 3549)" />
                        <rect id="Rectangle_13" data-name="Rectangle 13" width="227.809" height="106.65" rx="46" transform="translate(1173.615 3938.323)"/>
                    </g>
                </svg>
            </div>
            <div  className = {`${style.euphe} euphe`}> <span onMouseOver = {props.playDing}>{euphemisms[wordNumber]}</span> is Period</div>
         </div>
        </>

    )
}

export default InteractTwo